import { BehaviorSubject } from "rxjs";

class SpeechActions {
  static chat$ = new BehaviorSubject(false);
  static chat = this.chat$.asObservable();
  static chatOpen(value): void {
    this.chat$.next(value);
  }

  static skipHasOpened$ = new BehaviorSubject(false);
  static skipHasOpened = this.skipHasOpened$.asObservable();
  static skipHasOpen(value): void {
    this.skipHasOpened$.next(value);
  }

  static quiz$ = new BehaviorSubject(false);
  static quiz = this.quiz$.asObservable();
  static quizRecord(value): void {
    this.quiz$.next(value);
  }
}
export { SpeechActions };
